module.exports = __webpack_public_path__ + "img/lesson_04.cc5dca61.jpg";